import themeSword from './definitions/theme-sword';
import themeBloom from './definitions/theme-bloom';
import themeBig from './definitions/theme-big';
import themeEco from './definitions/theme-eco';
import themeMove from './definitions/theme-move';
import themeBecome from './definitions/theme-become';

export const themes = {
  big: {
    stylesSrc: themeBig,
  },
  bloom: {
    stylesSrc: themeBloom,
  },
  sword: {
    stylesSrc: themeSword,
  },
  eco: {
    stylesSrc: themeEco,
  },
  move: {
    stylesSrc: themeMove,
  },
  become: {
    stylesSrc: themeBecome,
  },
};

export const selectTheme = (themeName = 'sword') => {
  if (!window || !themeName || !themes[themeName] || !themes[themeName].stylesSrc) {
    return;
  }

  // Check for existing themes imports
  const themeStylesCustomAttr = 'data-wuk-theme-style';
  let themeStyleTag = document.querySelector(`style[${themeStylesCustomAttr}]`);

  // Ensure we have required style tag in place
  if (!themeStyleTag) {
    themeStyleTag = document.createElement('style');
    themeStyleTag.type = 'text/css';
    document.head.appendChild(themeStyleTag);
  }

  // Update custom attr for theme reference
  themeStyleTag.setAttribute(themeStylesCustomAttr, themeName);
  // Link to desired theme
  themeStyleTag.textContent = themes[themeName.toLowerCase()].stylesSrc;
};
